import type { ClientProjectActivity } from '@packages/types';

/**
 * True when an activity was logged from an inbox email and the reference to the
 * stored email is still present. Covers auto-detected (`EMAIL_AI_DETECTION`)
 * and manually allocated (`WEB_APP`) activities equally - both populate
 * `sourceRef` with the stored-email id when they came from email.
 *
 * A missing sourceRef is treated as "no email to preview" even when the source
 * enum says otherwise - legacy rows predate the sourceRef column and must not
 * render a half-state preview chip.
 */
export function hasSourceEmail(
  activity: Pick<ClientProjectActivity, 'source' | 'sourceRef'>,
): activity is typeof activity & { sourceRef: string } {
  return (
    (activity.source === 'EMAIL_AI_DETECTION' || activity.source === 'WEB_APP') &&
    !!activity.sourceRef
  );
}
